import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import test from '../views/test.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  // {
  //   path: '/',
  //   name: 'test',
  //   component: test // 路由懒加载，按需加载写法
  // },
  {
    path: '/',
    name: 'HomeView',
    component: HomeView // 路由懒加载，按需加载写法
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/contactUs.vue') // 路由懒加载，按需加载写法
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/about.vue') // 路由懒加载，按需加载写法
  },
  {
    path: '/news',
    name: 'news',
    component: () => import( '../views/news.vue') ,
    props: route => ({ id: route.query.id }) // 将查询参数作为 prop 传递给组件
  },
  {
    path: '/team',
    name: 'team',
    component: () => import( '../views/team.vue') 
  },
  {
    path: '/products',
    name: 'products',
    component: () => import( '../views/products.vue') ,
    props: route => ({ id: route.query.id }) // 将查询参数作为 prop 传递给组件
  },
  {
    path: '/newsContain',
    name: 'newsContain',
    component: () => import( '../views/newsContain.vue') 
  },
  {
    path: '/proContain',
    name: 'proContain',
    component: () => import( '../views/proContain.vue') 
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // 添加 scrollBehavior 配置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果有历史记录的位置（例如后退、前进）
      return savedPosition;
    } else {
      // 否则跳转时滚动到页面顶部
      return { x: 0, y: 0, behavior: 'smooth' };
    }
  }
})

export default router
